import { createEntityCollectionStore, getEntityCollectionActions } from '@core/ngrx-legacy';
import type {
  AskTemplate,
  CreateAskTemplate,
  UpdateAskTemplate,
} from '@tellent-ask-hr/templates-types';

const idSelector = (template: { id: number }) => template.id;
const { selectors, reducer, actions, namespace } = createEntityCollectionStore<AskTemplate>()(
  'AskHrTemplates',
  {
    idSelector,
    customActions: adapter => {
      const defaultActions = getEntityCollectionActions(adapter, idSelector);
      return {
        createOnePessimistic: (
          state,
          payload: { data: CreateAskTemplate; correlationId: string },
        ) => adapter.markAsPending(state, { entities: [payload.correlationId], scope: null }),

        fetchOne: (state, payload: { id: AskTemplate['id'] }) =>
          defaultActions.fetchOne(state, payload),

        updateOnePessimistic: (state, payload: { data: UpdateAskTemplate }) =>
          adapter.markAsPending(state, { entities: [payload.data.id], scope: null }),
        updateOnePessimisticFailed: (state, payload: { error: Error; data: UpdateAskTemplate }) =>
          adapter.setError(state, payload.error, {
            entities: [payload.data.id],
            scope: null,
          }),

        removeOnePessimisticSuccess: (state, payload: { id: AskTemplate['id'] }) =>
          adapter.removeOne(state, payload.id),

        duplicateTemplate: (state, payload: { data: CreateAskTemplate; correlationId: string }) =>
          adapter.markAsPending(state, { entities: [payload.correlationId], scope: null }),
        duplicateTemplateSuccess: defaultActions.createOnePessimisticSuccess,
        duplicateTemplateFailed: defaultActions.createOnePessimisticFailed,
      };
    },
  },
);

export {
  selectors as AskTemplatesSelectors,
  reducer as AskTemplatesReducer,
  actions as AskTemplatesActions,
  namespace as AskTemplatesNamespace,
};
